function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "flash_light"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 7h-14c-.552 0-1 .448-1 1v4c0 1.654 1.346 3 3 3v4c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-4c1.654 0 3-1.346 3-3v-4c0-.552-.448-1-1-1zm-2 6h-1c-.552 0-1 .448-1 1v5c0 .551-.449 1-1 1h-4c-.551 0-1-.449-1-1v-5c0-.552-.448-1-1-1h-1c-.551 0-1-.449-1-1v-3h12v3c0 .551-.449 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.105 5.447c.176.351.529.553.896.553.15 0 .303-.034.446-.105.494-.247.694-.848.447-1.342l-1-2c-.246-.494-.845-.695-1.341-.448-.494.248-.695.848-.448 1.342z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.553 5.895c.143.071.296.105.446.105.367 0 .72-.202.896-.553l1-2c.247-.494.047-1.095-.447-1.342-.495-.248-1.095-.047-1.342.447l-1 2c-.248.495-.047 1.095.447 1.343z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 6c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1s-1 .448-1 1v2c0 .552.448 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 14c-.552 0-1 .448-1 1v1c0 .552.448 1 1 1s1-.448 1-1v-1c0-.552-.448-1-1-1z"
})));

var Svg003Flashlight = function Svg003Flashlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg003Flashlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/003-flashlight.2e52d41b.svg";
export { ForwardRef as ReactComponent };